import React from 'react';
import styled from 'styled-components';
const VerticallyAligned = styled.p`
  &&&&& {
    display: flex;
    align-items: start;
  }
  &&&&& span {
    flex: 1;
    margin-left: 10px;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      flex: 1 1 auto;
    }
  }
`;
export const Paragraph = props => {
  var _children$, _children$$props;

  const {
    children
  } = props; // check to see if the first child is an image

  if ((_children$ = children[0]) !== null && _children$ !== void 0 && (_children$$props = _children$.props) !== null && _children$$props !== void 0 && _children$$props.src) {
    // if the first child is an image and there is only one child
    // we return a fragment with the image so as not to wrap in tags
    if (children.length === 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    } // we seperate the image and children for layout purposes in a flex container


    const image = children.shift();
    return /*#__PURE__*/React.createElement(VerticallyAligned, null, image, /*#__PURE__*/React.createElement("span", null, children));
  }

  return /*#__PURE__*/React.createElement("p", null, children);
};